import React from 'react';
import '../../pages/ebook/component/css/ebookCard.scss';
import { Skeleton } from '../Skeleton';
const EbookLoader = () => {
  return (
    <div className="w-100 float-start ebookV1Box cursorPointer position-relative rounded-3 overflow-hidden">
      <div className="w-100 ebookV1BoxIn bg-white position-relative shadow z-1">
        <div className={` w-100  float-start`}>
          <Skeleton variant="rectangular" width={'100%'} height={310} />
        </div>
      </div>
    </div>
  );
};

export default EbookLoader;
